import { useQuery } from '@tanstack/react-query';
import { emptyArray } from 'ui-components/default-props/empty';
import { supplierApi } from '../api/supplier-api';

export const useSuppliers = () => {
  const {
    data: suppliers = emptyArray,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['suppliers'],
    queryFn: () => supplierApi.getAllSuppliers(),
    select: (data) =>
      (data ?? [])
        .filter((item) => item?.name && item?.supplierId)
        .map((item) => ({
          label: item.name,
          value: String(item.supplierId),
        }))
        .sort((a, b) => a.label?.localeCompare(b.label) ?? 0),
  });

  return {
    suppliers,
    isLoading,
    error,
    refetch,
  };
};
